import { FC, useRef } from "react"
import { InputForm } from "../input/InputForm"
import { Formik } from "formik"
import { Chart, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from "chart.js"
import { Scatter } from "react-chartjs-2"
import ZoomPlugin from "chartjs-plugin-zoom"
import useFormValuesStore from "../../store/useFormValuesStore"

export type OutputFormProps = {
  /**
   * Request data to be displayed beneath the chart
   */
  requestData: any
  /**
   * Calculated response data to display to the user
   */
  responseData: any
}

export const OutputForm: FC<OutputFormProps> = ({ requestData, responseData }) => {
  const chartRef = useRef<Chart<any>>(null)
  const values = useFormValuesStore((state) => state.values)
  if (!responseData?.outputs) {
    return <div></div>
  }

  Chart.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, ZoomPlugin)

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top" as const,
      },
      zoom: {
        pan: {
          enabled: true,
        },
        zoom: {
          wheel: {
            enabled: true,
          },
          pinch: {
            enabled: true,
          },
          mode: "xy" as const,
        },
      },
    },
  }

  const data = {
    datasets: [
      {
        showLine: true,
        label: "ZC Yield",
        data: responseData.outputs.yieldtable.map((row: any, index: number) => {
          return { y: row.ZCYield, x: index + 1 }
        }),
        borderColor: "rgb(255, 99, 132)",
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
    ],
  }

  return (
    <div className="flex flex-col items-center justify-center space-y-3">
      <div className="mx-auto w-full max-w-sm md:max-w-md lg:max-w-lg">
        {responseData.outputs && (
          <div className="mx-auto w-full max-w-sm mb-8 text-center">
            <p className="text-sm mb-2">Bond market value:</p>
            <span className="text-5xl">${Number.parseFloat(responseData.outputs.Bond_MV).toFixed(2)}</span>
          </div>
        )}

        <div className="mb-8">
          <Scatter ref={chartRef} options={options} data={data} />
          <div className="flex justify-center">
            <button
              className="bg-brand-light rounded text-white py-2 px-8 mt-3 text-sm"
              type="button"
              onClick={() => chartRef.current?.resetZoom()}
            >
              Reset Zoom
            </button>
          </div>
        </div>

        <Formik initialValues={values} onSubmit={() => {}}>
          {({ errors, touched, handleChange, setFieldValue }) => (
            <InputForm
              errors={errors}
              touched={touched}
              handleChange={handleChange}
              setFieldValue={setFieldValue}
              readOnly
            />
          )}
        </Formik>
      </div>
    </div>
  )
}

